<div class="classification-form-container">
  <form [formGroup]="classificationForm" (ngSubmit)="onSubmit()" class="classification-form">
    <div class="classification-help" style="display:flex;justify-content:flex-end;margin-bottom:8px;">
      <button mat-icon-button type="button" (click)="showHelp()" matTooltip="Ayuda" aria-label="Ayuda de clasificación">
        <mat-icon>help_outline</mat-icon>
      </button>
    </div>
    <div class="form-group">
      <label for="status">Estado:</label>
      <select id="status" formControlName="status" class="form-control">
        <!-- Opción predeterminada -->
        <option value="" selected>Seleccione un estado</option>
        <!-- Opciones dinámicas desde statusOptions -->
        @for (option of statusOptions; track option) {
          <option [value]="option.value">
            {{ option.label }}
          </option>
        }
      </select>
      @if (classificationForm.get('status')?.invalid && classificationForm.get('status')?.touched) {
        <div class="error-message">
          Estado es requerido
        </div>
      }
    </div>

    <div class="form-group">
      <label for="observations">Observaciones:</label>
      <textarea id="observations" formControlName="observations" class="form-control" rows="3"
        placeholder="Ingrese observaciones sobre la alarma">
      </textarea>
    </div>

    <div class="form-actions">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        Cancelar
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="classificationForm.invalid">
        Enviar Clasificación
      </button>
    </div>

    <!-- Mensajes de éxito o error -->
    <!-- <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div> -->
    @if (errorMessage()) {
      <div class="alert alert-danger">{{ errorMessage() }}</div>
    }
  </form>
</div>
